import { PagingDetail } from "../common/request-response/paging-detail";
import { IImportHistory } from "../importHistory/importHistory.model";

export class LocationRequest {
    locationId: number;
    name: string;
    code1: string;
    code2: string;
    status: number;
    organisationId: number;
    createdBy: number;
    createdOn: number;
    updatedBy: number;
    updatedOn: number;
    userName: string;
}

export class AssignLocationToEmployeesRequest {
    organisationId: number;
    locationId: number;
    userOrgMappingIds: number[];
    updatedBy: number;
    updatedOn: number;
    userName: string;
}

export class GetEmployeeForLocationAssignmentRequest extends PagingDetail {
    organisationId: number;
    pageNo: number;
    sortOrder: number;
    sortColumn: string;
    searchText: string;
    companyId: number;
}

export class GetLocationListForGridRequest extends PagingDetail {
    organisationId: number;
    status: number;
    sortColumn: string;
    searchText: string;
}

export class GetLocationByLocationIdsRequest {

    locationIds: number[];
}

export class GetLocationByOrgIdAndStatusRequest {
    organisationId: number;
    status: number;
}

export class GetLocationByLocationIdRequest {
    locationId: number;
}




export class LocationResponse {
    locationId: number;
    name: string;
    code1: string;
    code2: string;
    status: number;
    organisationId: number;
    accountingSystemParameter: string;
    createdBy: number;
    createdOn: number;
    updatedBy: number;
    updatedOn: number;
}

export class LocationResponseForGrid extends LocationResponse {
    setupDate: Date;
    numberOfClaimants: number;
    isRowHighlighted: boolean;
    statusText: string;
    selected: boolean;
    isDeactivateDisabled: boolean;
    isDeactivateHidden: boolean;
    isEditDisabled: boolean;
    isActivateHidden: boolean = false;
}

export class LocationListForGridResponse {
    locationList: LocationResponseForGrid[];
    totalLocationCount: number;
    totalActiveLocationCount: number;
    totalInActiveLocationCount: number;
}

export class EmployeeForLocationAssignmentResponse {
    userOrgMappingId: number;
    userId: number;
    employeeId: string;
    employeeName: string;
    employeeEmail: string;
    status: number;
    updatedOn: number;
    locationId: number;
    locationName: string;
    isRowHighlighted: boolean;
    selected: boolean;
    locationStatus: number;
    isEditDisabled: boolean;
    isCheckboxDisabled: boolean;
}

export class EmployeeListForLocationAssignmentResponse {
    employeeList: EmployeeForLocationAssignmentResponse[];
    totalEmployessCount: number;
    totalEmployessCountWithLocation: number;
    totalEmployessCountWithOutLocation: number;
}

export class EmployeeForLocationAssignment {
    userOrgMappingId: number;
    employeeName: string;
    locationId: number;
    locationName: string;
    userId: number;
}


export class ActiveLocationForAssignResponse {
    locationId: number;
    locationName: string;
}

export class GetLocationShortDetailsResponse {
    locationId: number;
    locationName: string;
    locationCode1: string;
    locationCode2: string;
    nameCode: string;
}

export class LocationCsvRecord {
    locationName: string;
    locationCode1: string;
    locationCode2: string;
    error: string;

}

export class LocationCsvRecordExport {
    LocationName: string;
    LocationCode1: string;
    LocationCode2: string;
    Error: string;
}

export class RequestAddLocationImportHistory {
    importHistory: IImportHistory;
    failedDataList: LocationCsvRecord[];

}

export class AddUpdateLocationModel {
    constructor(
        public title: string,
        public locationId: number,
        public isEditMode: boolean = false,
        public assignedEmployeesCount: number
    ) {

    }
}

export class DeactivateLocationModel {
    constructor(public locationId: number, public locationName: string, public assignedEmployeesCount: number) {

    }
}

export class BulkActionOnLocationRequest {
    organisationId: number;
    locationIds: number[];
    updatedBy: number;
    status: number;
    userName: string;
}

export class LocationFormModel {
    locationId: number;
    location_name: string;
    location_code1: string;
    location_code2: string;
    location_status: number;
    location_status_boolean: boolean;
}